module.exports = __webpack_public_path__ + "static/media/user-md-icon-green.3bd8c5c2.svg";